import { Route, Routes } from 'react-router-dom';

import ClientStatus from '../../../features/clientDetails/components/clientStatus/ClientStatus';
import ClientForm from '../ClientForm';
import ClientListingPage from '../ClientListingPage';
import AddClientOptions from '../components/AddClientOptions';
import BulkUploadSpreadsheets from '../components/bulkUpload/BulkUploadSpreadsheets';

const ClientListingRoutes = () => (
  <Routes>
    <Route path="" element={<ClientListingPage />} />
    <Route path="/add" element={<ClientForm />} />
    <Route path=":clientId/edit" element={<ClientForm />} />
    <Route path="/:parentId/add" element={<ClientForm />} />
    <Route path="/addclientoptions" element={<AddClientOptions />} />
    <Route path="/import-excel" element={<BulkUploadSpreadsheets />} />
    <Route path="/client-status" element={<ClientStatus />} />
  </Routes>
);

export default ClientListingRoutes;
